
//中文版本
export const m = {
  title: '2020中国义乌五金电器博览会',
  bigtitle: '2020中国义乌五金电器博览会采购商预登记',
  login: '登录',
  verify:'请输入验证码',
  verifystate: '验证通过',
  drag: '拖动滑块验证',
  next:'下一步',
  code:'获取验证码',
  phoneError: '您输入的手机号码有误',
  phone:'请输入您的手机号',
  codefalse:'您输入的验证码有误',
  foot:' 应公安部门要求，须获取客户身份证信息，组委会向您郑重承诺，客户信息仅用于展会预登记系统，现场凭本人身份证办理采购商证件（身份证号码填写错误将导致采购商证件无法打印）。了解更多展会信息请点击' +
      ' ',
  upinfo:'上传身份证照片和头像',
  upportrait:'上传人像页照片',
  upnational:'上传国徽页照片',
  upreal:'上传您的真实头像',
  fill:'填写问卷调查',
  submit:'提交',
  subheading1:'01 : 您感兴趣的产品类别是？（多选）',
  subheading2:'02 : 您公司的业务性质是？（单选）',
  subheading3:'03 : 您的参会目的是？（多选）',
  subheading4:'04 : 您通过什么方式知道此展会（多选）',
  subheading5:'05 : 您的职务（单选）',
  //subheading1
  s1: '1. 日用五金',
  s1_1: '1.1 不锈钢制品',
  s1_2: '1.2 五金器皿',
  s1_3: '1.3 厨房用品',
  s1_4: '1.4 刀剪',
  s2: '2. 五金工具',
  s2_1: '2.1 工具配件',
  s2_2: '2.2 劳保用品',
  s2_3: '2.3 电动/气动工具',
  s2_4: '2.4 园林工具',
  s2_5: '2.5 手动/汽保工具',
  s2_6: '2.6 其他',
  s3: '3. 电子电器',
  s3_1: '3.1 灯具灯饰',
  s3_2: '3.2 数码产品',
  s3_3: '3.3 小家电',
  s3_4: '3.4 仪器仪表',
  s3_5: '3.5 电工/电器产品',
  s4: '4. 机电机械',
  s4_1: '4.1 清洁环保设备',
  s4_2: '4.2 机械设备',
  s4_3: '4.3 智能装备制造',
  s4_4: '4.4 机电产品',
  s5: '5. 建筑五金',
  s5_1: '5.1 标准紧固件',
  s5_2: '5.2 五金配件',
  s5_3: '5.3 卫浴洁具',
  s5_4: '5.4 水暖器材',
  s5_5: '5.5 门锁挂锁',
  ht:'五金工具',
  at:'汽保工具',
  ah:'建筑五金',
  psw:'水暖洁具',
  lockset:'锁具',
  dh:'日用五金',
  eea:'电子电器',
  me:'机械设备',
  ef:'机电产品',
  ep:'清洁环保设备',
  iem:'智能装备制造',
  other:'其他（请列明）',
  //subheading2
  manufacturer:'生产商',
  wholesaler : '批发商',
  agent: '代理人',
  retailer: '零售商',
  ie:'进出口商',
  ms:'商场/超市',
  nt:'网商',
  ca:'商会/协会',
  gm:'政府部门/媒体',
  //subheading3
  buy:'采购产品',
  seek:'寻求合作',
  mno:'新品订货',
  seekagents:'征求代理',
  gii:'了解行业发展',
  gintnp:'了解新技术、新产品',
  fpe:'为下一次参展进行考察',
  //subheading4
  mail:'电子邮件 ',
  ti:'电话邀请',
  sms:'短信',
  dm:'邮寄资料',
  oa:'网络广告',
  se:'搜索引擎',
  mow:'官方网站',
  mw:'官方微信',
  outdoor:'户外广告',
  pp: '专业刊物',
  oe:'相关展会',
  rc:'客户介绍',
  ies:'参展商/供应商邀请',
//subheading5
  ogm:'企业主/总经理',
  dmpr:'部门经理/采购代表',
  br:'业务代表',
  fillinfo:'填写个人信息',
  name:'姓名',
  company:'单位名称',
  ctype:'证件类型',
  cnumber :'身份证',
  position :'职务（非必填）',
  address :'地址',
  mobile :'手机号',
  email:'邮箱',
  emailError: '请输入正常的邮箱',
  emailInput: '请输入邮箱',
  country:'国家/地区',
  countryError: '请输入国家/地区',
  nullname:'请输入内容',
  nullcompany:'请输入单位名称',
  nullcnumber:'请输入内容',
  nullposition:'请输入职务',
  nulladdress:'请输入内容',
  nullmobile:'请输入内容',
  secondtitle:'2020中国义乌五金电器博览会',
  dear:'尊敬的',
  sex:'先生/女士',
  end:'恭喜您已成功完成2020中国义乌五金电器博览会预登记!',
  ending:'感谢您预约参加2020中国义乌五金电器博览会，您的预登记我们将会在三个工作日内审核，请您耐心等待!',
  tips:'温馨提示：凭本人身份证至自助办证机或人工窗口办理采购商证件，展会期间使用人脸采集门禁系统，一人一证，不可转借，谢谢合作！',
  tips1: '受疫情影响，2020中国义乌五金电器博览会线下展会延期至2021年4月20-22日，延期不延展，线上展会于4月20-6月12日举行，您可点击',
  tips2: '线上五金会',
  tips3: '参加，直接与参展商进行贸易对接。',
  tips4: '请长按识别图中二维码返回小程序参加线上展会',
  ing:'预约审核中…',
  date:'展出时间：',
  venue:'展览地点：',
  place:'义乌国际博览中心',
  purchasers:'采购商报到处：',
  purchasers2:'入场方式说明：',
  place2: '获取预登记成功确认页（含二维码或条码），前往自助办证机或人工柜台凭身份证取证。',
  place1:'1、义乌国际博览中心A1馆客商报到处<br>' + '2、义乌国际博览中心综合楼客商报到处',
  telconsel:'咨询电话：',
  modify:'立即修改',
  confirm:'确认号：',
  nameError: '姓名不能为空',
  msgTime: '2s后将跳转到线上博览会',
}
